import { Navigate, useParams } from "react-router";
import { ROUTER_BASE } from "../Components/Link";

export function CompatibleEigentxRedirect() {
  const { txhash } = useParams();
  return <Navigate to={`/${ROUTER_BASE}/eigentx/${txhash}`} />;
}
